import { render } from "./RightToErasurePage.vue?vue&type=template&id=060d0fc6&ts=true"
import script from "./RightToErasurePage.vue?vue&type=script&lang=ts"
export * from "./RightToErasurePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Dashboard/Profile/RightToErasurePage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "060d0fc6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('060d0fc6', __exports__)) {
    api.reload('060d0fc6', __exports__)
  }
  
  module.hot.accept("./RightToErasurePage.vue?vue&type=template&id=060d0fc6&ts=true", () => {
    api.rerender('060d0fc6', render)
  })

}


export default __exports__